import BaseModelBuyoutPartner from "@/models/BaseModelBuyoutPartner.js";
import BaseModelBuyoutProgramDetail from "@/models/BaseModelBuyoutProgramDetail.js";

export const PartnerGridConfig = {
	//list: BaseModelBuyoutPartner.list,
	columns: BaseModelBuyoutPartner.columns,
	grid: {
		gridId: 'buyoutPartnerGrid',
		height: 500,
		checkbox: true,
		edit: false,
		delete: false,
		info: true,
		pageSize: 100,
		groupable: true,
		document:true,
		actionsColumnWidth:80
	}
}

export const ProgramDetailGridConfig = {
	//list: BaseModelBuyoutProgramDetail.list,
	columns: BaseModelBuyoutProgramDetail.columns,
	grid: {
		gridId: 'buyoutProgramDetailGrid',
		height: 500,
		checkbox: true,
		edit: false,
		delete: false,
		pageSize: 100,
		groupable: true,
		save: true,
		//document:true
	}
}

export const ToolBarConfig = {
	items: [
		{
			id: "btnBoughtOut",
			type: "button",
			text: "Mark As Bought Out",
			showIcon: "toolbar",
			icon: "check-circle",
			attributes: { "class": "btn btn-primary float-right-btn" }
		},
		{
			id: "btnStartBuyout",
			type: "button",
			text: "Start Buyout",
			showIcon: "toolbar",
			icon: "check-circle",
			attributes: {
				"class": "btn btn-tertiary float-right-btn"
			}
		},
		{
			id: "btnStartRetire",
			type: "button",
			text: "Start Retirement",
			showIcon: "toolbar",
			icon: "check-circle",
			attributes: {
				"class": "btn btn-tertiary float-right-btn"
			}
		}
		
	]
}

export const BuyoutDetailToolBarConfig = {
	items: [
		{
			id: "btnApproveBuyout",
			type: "button",
			text: "Approve Buyout",
			showIcon: "toolbar",
			icon: "check",
			attributes: { "class": "btn btn-primary float-right-btn" }
		},
		{
			id: "btnBack",
			type: "button",
			text: "Back to Buyout Summary",
			showIcon: "toolbar",
			icon: "undo",
			attributes: { "class": "btn btn-secondary float-right-btn" }
		},
	]
}